import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Corporatecabbookinginkolkata() {



  const cardData =
  {
    keyword: 'Corporate Cab Bookings in Kolkata',
    heading: 'Aaryan Travels: Corporate Cab Bookings in Kolkata',
    headingDescription: 'Aaryan Travels offers professional Corporate Cab Bookings in Kolkata for businesses, IT parks, and industrial zones that require reliable transportation for executives, employees, and clients. Whether it’s daily pickup and drop, airport transfers from Netaji Subhas Chandra Bose International Airport, or intercity travel to Durgapur, Ranchi, or Siliguri, our fleet of sedans, SUVs, and tempo travellers ensures safe and punctual journeys. With uniformed chauffeurs, GPS-enabled vehicles, monthly billing options, and 24/7 support, we deliver seamless corporate mobility across Salt Lake, New Town, Park Street, Howrah, and other commercial hubs. Aaryan Travels is your trusted partner for dependable corporate cab bookings in Kolkata.',

    top: 'Top Places to Visit in Kolkata with Aaryan Travels',

"topPlaces": [
  {
    "title": "Victoria Memorial",
    "description": "Victoria Memorial is a grand white marble monument built in honor of Queen Victoria. Surrounded by lush gardens and water bodies, it is now a museum showcasing colonial-era paintings, artifacts, and royal memorabilia. During the evening, the monument is beautifully illuminated. The sprawling lawns are perfect for leisure walks. Victoria Memorial is Kolkata’s iconic symbol of history and elegance."
  },
  {
    "title": "Howrah Bridge (Rabindra Setu)",
    "description": "Howrah Bridge is one of the world’s busiest cantilever bridges, connecting Kolkata and Howrah over the Hooghly River. Built without nuts or bolts, it stands as an engineering marvel. The bridge glows stunningly at night. Watching ferries and daily life around the riverbank is a mesmerizing experience. Howrah Bridge is Kolkata’s timeless gateway of connectivity and pride."
  },
  {
    "title": "Dakshineswar Kali Temple",
    "description": "Dakshineswar Kali Temple, located on the banks of the Hooghly River, is dedicated to Goddess Bhavatarini, a form of Kali. Associated with the saint Sri Ramakrishna Paramahamsa, it attracts thousands of devotees daily. The temple complex includes bathing ghats and peaceful surroundings. Dakshineswar Temple is Kolkata’s sacred haven of divine energy."
  },
  {
    "title": "Belur Math",
    "description": "Belur Math is the headquarters of the Ramakrishna Mission founded by Swami Vivekananda. Its architecture blends Hindu, Christian, and Islamic styles, symbolizing unity among religions. The tranquil riverfront setting makes it ideal for meditation and reflection. Evening prayers here are deeply soothing. Belur Math is Kolkata’s beacon of peace and spiritual harmony."
  },
  {
    "title": "Park Street",
    "description": "Park Street is Kolkata’s entertainment hub known for iconic restaurants, bakeries, and nightlife. Legendary eateries like Flurys and Peter Cat draw food lovers from across the globe. The street comes alive with music, lights, and festive decor during Christmas and New Year. Park Street is Kolkata’s vibrant boulevard of joy and celebration."
  },
  {
    "title": "Indian Museum",
    "description": "Founded in 1814, the Indian Museum is India’s oldest and largest museum. It houses Egyptian mummies, dinosaur fossils, ancient sculptures, and Mughal paintings. Each gallery offers a fascinating journey through history, art, and science. The massive building itself is a colonial architectural gem. Indian Museum is Kolkata’s treasure trove of knowledge."
  },
  {
    "title": "St. Paul’s Cathedral",
    "description": "St. Paul’s Cathedral is a beautiful Gothic-style church known for its towering spires and stained-glass windows. Built in 1847, it offers a peaceful retreat amidst the city’s buzz. The church looks especially enchanting during Christmas. Its lush lawns add to the serenity. St. Paul’s Cathedral is Kolkata’s elegant landmark of faith."
  },
  {
    "title": "Science City",
    "description": "Science City is India’s largest science center featuring interactive exhibits, a space theater, ropeway rides, and illusion tunnels. It offers fun learning experiences for both kids and adults. The Earth Exploration Hall and time travel simulators are crowd favorites. Science City is Kolkata’s futuristic world of education and entertainment."
  },
  {
    "title": "Kalighat Temple",
    "description": "Kalighat Temple is one of the 51 Shakti Peethas dedicated to Goddess Kali. Despite the crowds, it radiates strong spiritual energy. Devotees come to offer prayers and witness rituals. The surrounding market sells flowers, prasad, and religious items. Kalighat Temple is Kolkata’s ancient seat of devotion."
  },
  {
    "title": "Eco Park (Prakriti Tirtha)",
    "description": "Eco Park is a vast urban recreation space with themed gardens, water bodies, cycling tracks, and adventure sports. Replica monuments like the Eiffel Tower and Seven Wonders attract photo enthusiasts. Families flock here for picnics, boating, and evening leisure. Eco Park is Kolkata’s refreshing escape into greenery and fun."
  }
],


"services": [
  {
    "name": "Corporate Cab Bookings in Kolkata",
    "description": "Corporate Cab Bookings in Kolkata provide seamless and reliable transportation solutions tailored for businesses of all sizes. Whether for daily employee commutes, client transfers, or corporate events, this service ensures punctual pickups, professional chauffeurs, and a fleet of well-maintained vehicles. With flexible booking options and real-time tracking, companies can efficiently manage their transportation needs while prioritizing comfort and safety for their staff and guests."
  },
  {
    "name": "Book Business Cab Kolkata",
    "description": "Book Business Cab Kolkata offers hassle-free booking of business cabs with just a few clicks. Designed for busy professionals and corporate clients, this service ensures timely rides with clean, comfortable vehicles and experienced drivers, making business travel smooth and stress-free."
  },
  {
    "name": "Corporate Taxi Service Kolkata",
    "description": "Corporate Taxi Service Kolkata specializes in providing dependable taxi services for corporate clients, including employee transfers, airport pickups, and event transportation. The service emphasizes professionalism, punctuality, and safety to support businesses in their daily operations."
  },
  {
    "name": "Office Cab Hire Kolkata",
    "description": "Office Cab Hire Kolkata offers dedicated transportation solutions for employees commuting to and from the office. With flexible schedules, reliable vehicles, and courteous drivers, this service enhances workforce productivity and reduces travel-related stress."
  },
  {
    "name": "Staff Transport Kolkata",
    "description": "Staff Transport Kolkata provides safe and affordable transportation options for company staff. Focused on convenience and reliability, this service helps businesses maintain smooth daily operations by ensuring employees reach work on time."
  },
  {
    "name": "Corporate Chauffeur Kolkata",
    "description": "Corporate Chauffeur Kolkata delivers premium chauffeur-driven vehicles for corporate clients who demand discretion, professionalism, and comfort. Ideal for executive travel and VIP transfers, this service offers a high level of personalized attention and luxury."
  },
  {
    "name": "Monthly Corporate Cab Kolkata",
    "description": "Monthly Corporate Cab Kolkata offers subscription-based cab rentals for businesses requiring long-term transportation solutions. This service provides consistent vehicle availability, competitive pricing, and dedicated customer support for hassle-free corporate travel management."
  },
  {
    "name": "Affordable Corporate Cab Kolkata",
    "description": "Affordable Corporate Cab Kolkata delivers budget-friendly transportation options for companies without compromising on quality or safety. Transparent pricing and reliable service make it a preferred choice for cost-conscious businesses."
  },
  {
    "name": "Executive Corporate Cab Kolkata",
    "description": "Executive Corporate Cab Kolkata caters to senior executives and VIPs, offering luxury vehicles and professional chauffeurs to ensure a comfortable and prestigious travel experience. The service focuses on punctuality, privacy, and top-notch customer care."
  },
  {
    "name": "Corporate Car Rental Kolkata",
    "description": "Corporate Car Rental Kolkata provides a wide range of vehicles for corporate use, available for short and long-term rentals. This service includes well-maintained cars and skilled drivers to support diverse business transportation needs."
  },
  {
    "name": "Corporate Travel Cab Kolkata",
    "description": "Corporate Travel Cab Kolkata specializes in managing corporate travel logistics, including airport transfers, client meetings, and business tours. With a focus on efficiency and professionalism, this service ensures smooth and timely transportation for all corporate travel requirements."
  },
  {
    "name": "Premium Corporate Cab Kolkata",
    "description": "Premium Corporate Cab Kolkata offers upscale corporate transportation featuring luxury vehicles and experienced chauffeurs. Designed for VIP clients and important business occasions, this service guarantees a refined and comfortable travel experience."
  },
  {
    "name": "Online Corporate Cab Booking Kolkata",
    "description": "Online Corporate Cab Booking Kolkata provides an easy-to-use digital platform for booking corporate cabs instantly. With real-time ride tracking, instant confirmations, and multiple payment options, this service streamlines corporate transportation management."
  },
  {
    "name": "Trusted Corporate Cab Kolkata",
    "description": "Trusted Corporate Cab Kolkata is known for its dependable and professional service, earning the confidence of businesses across the city. Offering well-maintained vehicles, trained chauffeurs, and transparent pricing, this service is a reliable partner for corporate travel."
  },
  {
    "name": "Corporate Event Cab Kolkata",
    "description": "Corporate Event Cab Kolkata specializes in transportation services tailored for corporate events, conferences, and seminars. The service ensures timely pickups, spacious vehicles, and professional drivers to handle group travel efficiently and comfortably."
  }
],
"tableData": [
  ["Corporate Cab Bookings in Kolkata", "Book Business Cab Kolkata"],
  ["Corporate Taxi Service Kolkata", "Office Cab Hire Kolkata"],
  ["Staff Transport Kolkata", "Corporate Chauffeur Kolkata"],
  ["Monthly Corporate Cab Kolkata", "Affordable Corporate Cab Kolkata"],
  ["Executive Corporate Cab Kolkata", "Corporate Car Rental Kolkata"],
  ["Corporate Travel Cab Kolkata", "Premium Corporate Cab Kolkata"],
  ["Online Corporate Cab Booking Kolkata", "Trusted Corporate Cab Kolkata"],
  ["Corporate Event Cab Kolkata", "—"]
],

"whychoose": [
  {
    "WhyChooseheading": "Corporate Cab Bookings in Kolkata",
    "WhyChoosedescription": "Aaryan Travels offers reliable corporate cab booking services in Kolkata tailored to your business travel needs."
  },
  {
    "WhyChooseheading": "Punctual and Professional Chauffeurs",
    "WhyChoosedescription": "Our experienced drivers ensure timely pickups and drop-offs, keeping your corporate schedule on track."
  },
  {
    "WhyChooseheading": "Clean and Comfortable Vehicles",
    "WhyChoosedescription": "Travel in sanitized, air-conditioned cabs maintained to provide a comfortable and safe ride."
  },
  {
    "WhyChooseheading": "Drivers Well-Acquainted with Kolkata Routes",
    "WhyChoosedescription": "Our chauffeurs have in-depth knowledge of Kolkata’s roads to ensure efficient and smooth travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Enjoy upfront pricing inclusive of fuel, tolls, and driver allowances for hassle-free billing."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Booking Assistance",
    "WhyChoosedescription": "Our support team is available round the clock to help with bookings and corporate travel inquiries."
  },
  {
    "WhyChooseheading": "Flexible Booking Options for One-Way or Round Trips",
    "WhyChoosedescription": "Choose rides tailored to your business schedule, whether one-way or round trip."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicle Options",
    "WhyChoosedescription": "Select from sedans, SUVs, and luxury cars to suit your corporate travel preferences."
  }
]
















  }

const faqData = [
  {
    question: 'Does Aaryan Travels offer corporate cab bookings in Kolkata?',
    answer: 'Yes, Aaryan Travels provides reliable and professional corporate cab booking services in Kolkata for all your business travel needs.',
  },
  {
    question: 'How can I book corporate cabs in Kolkata with Aaryan Travels?',
    answer: 'You can easily book through our website, mobile app, or by contacting our 24x7 corporate customer support team.',
  },
  {
    question: 'What types of vehicles are available for corporate cab bookings in Kolkata?',
    answer: 'Aaryan Travels offers a range of vehicles including sedans, SUVs, and premium cars suitable for corporate travel.',
  },
  {
    question: 'Are the drivers experienced for corporate cab services in Kolkata?',
    answer: 'Yes, our drivers are licensed, professional, and familiar with Kolkata routes to ensure timely and safe travel.',
  },
  {
    question: 'Can I customize pickup and drop-off locations for corporate cab bookings in Kolkata?',
    answer: 'Yes, you can specify preferred pickup and drop-off points anywhere within Kolkata and nearby business areas.',
  },
  {
    question: 'Is corporate cab service available 24x7 in Kolkata?',
    answer: 'Yes, Aaryan Travels offers round-the-clock corporate cab services to meet your business schedules.',
  },
  {
    question: 'Are safety and hygiene protocols followed for corporate cab services?',
    answer: 'All vehicles are sanitized regularly, and drivers adhere to strict safety and hygiene guidelines.',
  },
  {
    question: 'What payment options are accepted for corporate cab bookings in Kolkata?',
    answer: 'We accept cash, digital wallets, UPI, credit/debit cards, and corporate account payments.',
  },
  {
    question: 'Is customer support available during corporate cab rides?',
    answer: 'Yes, our 24x7 customer support team is available to assist you throughout your journey.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Arjun Mukherjee',
    feedback: 'Aaryan Travels provided excellent corporate cab service in Kolkata — punctual and professional drivers made all the difference.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Nandita Sen',
    feedback: 'Smooth and reliable corporate cab bookings with Aaryan Travels in Kolkata. Highly recommended for business travel!',
    rating: 5,
  },
];




























































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Best Cab Services in Pune", link: "best-cab-services-in-pune" },
    { place: "/images/keyword/3.jpg", text: "Best Cab Services in Kochi", link: "best-cab-services-in-kochi" },
    { place: "/images/keyword/4.jpg", text: "Cab booking from Mumbai to Pune", link: "cab-booking-from-mumbai-to-pune" },
    { place: "/images/keyword/5.jpg", text: "Cab from Pune to Mahabaleshwar", link: "cab-from-pune-to-mahabaleshwar" },
    { place: "/images/keyword/6.jpg", text: "Monthly Cab hire contract in Hyderabad", link: "monthly-cab-hire-contract-in-hyderabad" },
    { place: "/images/keyword/7.jpg", text: "Taxi Services from Pune to Shirdi", link: "taxi-services-from-pune-to-shirdi" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Pune Corporate Cab", link: "mumbai-to-pune-corporate-cab" },
    { place: "/images/keyword/10.jpg", text: "Outstation Cab Services from Pune", link: "outstation-cab-services-from-pune" },
    { place: "/images/keyword/11.jpg", text: "Innova Crysta rental in Pune", link: "innova-crysta-rental-in-pune" },
    { place: "/images/keyword/12.jpg", text: "Corporate Cab hire in Pune", link: "corporate-cab-hire-in-pune" },
    { place: "/images/keyword/13.jpg", text: "Pune to Shirdi Corporate Cab booking", link: "pune-to-shirdi-corporate-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Corporate Cab Services", link: "pune-to-mumbai-corporate-cab-services" },
    { place: "/images/keyword/15.jpg", text: "Monthly Corporate Cab rental in Chennai", link: "monthly-corporate-cab-rental-in-chennai" },
    { place: "/images/keyword/16.jpg", text: "Wedding Corporate Cab bookings in Pune", link: "wedding-cab-bookings-in-pune" },
    { place: "/images/keyword/17.jpg", text: "Corporate Cab Services in Kharadi, Pune", link: "corporate-cab-services-in-kharadi-pune" },
    { place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranchi", link: "corporate-cab-services-in-ranchi" },
    { place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Vadodara", link: "corporate-cab-services-in-vadodara" },
    { place: "/images/keyword/20.jpg", text: "Corporate Cab booking in Ranchi", link: "corporate-cab-booking-in-ranchi" },
    { place: "/images/keyword/21.jpg", text: "Corporate Cab booking in Vadodara", link: "corporate-cab-booking-in-vadodara" },
    { place: "/images/keyword/22.jpg", text: "Taxi booking in Ranchi", link: "taxi-booking-in-ranchi" },
    { place: "/images/keyword/23.jpg", text: "Corporate Cab Services in India", link: "corporate-cab-services-in-india" },
    { place: "/images/keyword/24.jpg", text: "Taxi Services in Vadodara, Gujarat", link: "taxi-services-in-vadodara-gujarat" },
    { place: "/images/keyword/25.jpg", text: "Taxi booking in Vadodara", link: "taxi-booking-in-vadodara" }
  ];









const corporateCabBookingsKolkataSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Corporate Cab Bookings in Kolkata",
  "description": "Aaryan Travels provides reliable and affordable corporate cab bookings in Kolkata, offering executive, staff transport, and chauffeur-driven corporate taxi services for businesses.",
  "provider": {
    "@type": "Organization",
    "name": "Aaryan Travels",
    "url": "https://aaryantravels.com"
  },
  "areaServed": {
    "@type": "City",
    "name": "Kolkata"
  },
  "serviceType": "Corporate Cab Booking Service",
  "keywords": "Corporate Cab Bookings in Kolkata, Book Business Cab Kolkata, Corporate Taxi Service Kolkata, Office Cab Hire Kolkata, Staff Transport Kolkata, Corporate Chauffeur Kolkata, Monthly Corporate Cab Kolkata, Affordable Corporate Cab Kolkata, Executive Corporate Cab Kolkata, Corporate Car Rental Kolkata, Corporate Travel Cab Kolkata, Premium Corporate Cab Kolkata, Online Corporate Cab Booking Kolkata, Trusted Corporate Cab Kolkata, Corporate Event Cab Kolkata"
};






  return (
    <div>

<Helmet>
  <title>Corporate Cab Bookings in Kolkata | Affordable Business Taxi Service | Aaryan Travels</title>
  <meta
    name="description"
    content="Book corporate cab services in Kolkata with Aaryan Travels for reliable, affordable, and chauffeur-driven office transport, executive cabs, and staff transport."
  />
  <meta
    name="keywords"
    content="Corporate Cab Bookings in Kolkata, Book Business Cab Kolkata, Corporate Taxi Service Kolkata, Office Cab Hire Kolkata, Staff Transport Kolkata, Corporate Chauffeur Kolkata, Monthly Corporate Cab Kolkata, Affordable Corporate Cab Kolkata, Executive Corporate Cab Kolkata, Corporate Car Rental Kolkata, Corporate Travel Cab Kolkata, Premium Corporate Cab Kolkata, Online Corporate Cab Booking Kolkata, Trusted Corporate Cab Kolkata, Corporate Event Cab Kolkata"
  />
  <script type="application/ld+json">
    {JSON.stringify(corporateCabBookingsKolkataSchema)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-3" data-cursor="-opaque">
                   {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>










      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/68.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaryan Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaryan Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919730707888" className="pc-call">+91 9730707888</a>
                      <a href="tel:+919833377051" className="pc-call">+91 9833377051</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919730707888"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919730707888" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:bookings@aaryantravels.com" className="pc-email">
                      bookings@aaryantravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aryan Travels Pune Head Office</strong><br />
                      Flat 304, Plot-82, Prathmesh Krupa, Purnanagar/Chikhali Pune- 411019.
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Corporatecabbookinginkolkata;